function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Ellipse_35",
  width: 220.196,
  height: 220.196,
  x: 0,
  y: 0,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 33
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 23
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ec1d1d",
  floodOpacity: 0.302
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#3c4950}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1301",
  transform: "translate(69 36)"
}, /*#__PURE__*/React.createElement("text", {
  id: "New_Trip",
  fill: "#3c4950",
  fontFamily: "Arial",
  fontSize: "21px",
  fontWeight: 600,
  transform: "translate(44.785 108.511)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -42.966,
  y: 0
}, "New Trip")), /*#__PURE__*/React.createElement("g", {
  id: "Group_33"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#Ellipse_35)",
  transform: "translate(-69 -36)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_35-2",
  fill: "#fff",
  stroke: "#ec1d1d",
  strokeWidth: "2px",
  transform: "translate(69 36)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 41.098,
  cy: 41.098,
  r: 41.098,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41.098,
  cy: 41.098,
  r: 40.098,
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "noun_business_trip_2735415",
  transform: "translate(26.527 17.358)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_89"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_42",
  cx: 4.387,
  cy: 4.387,
  r: 4.387,
  className: "cls-3",
  transform: "translate(14.348)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_631",
  d: "M27.386 69.255a1.559 1.559 0 0 0 .985-1.36c.482-8.238-.549-13.612-3.063-15.975A4.118 4.118 0 0 0 22.6 50.7c-.033 0-.065-.005-.1-.005h-7.531a1.5 1.5 0 0 0-.23.019c-1.451.122-7.082 1.327-9.975 12.46a1.562 1.562 0 0 0-.049.36h-.783a1.952 1.952 0 0 0-1.95 1.95V70H1.56A1.565 1.565 0 0 0 0 71.565v12.544a1.565 1.565 0 0 0 1.56 1.56h.016v.813a.585.585 0 0 0 1.17 0v-.813h6.721v.813a.585.585 0 0 0 1.17 0v-.813h.016a1.565 1.565 0 0 0 1.56-1.56V71.565A1.565 1.565 0 0 0 10.653 70h-.423v-4.513a1.952 1.952 0 0 0-1.95-1.95H7.9c1.639-6 4.019-8.293 5.566-9.171V84.65a2.411 2.411 0 0 0 4.822 0v-17.6h.9v17.6a2.411 2.411 0 0 0 4.822 0V55.4c.872 1.813 1.648 5.465 1.247 12.317a1.559 1.559 0 0 0 1.252 1.619v.932h-1.35v7.865h3.575v-7.868h-1.349v-1.01zM10.58 73.336v.564H1.633v-.569zm-1.129-7.849V70H2.762v-4.513a1.171 1.171 0 0 1 1.17-1.17H4.9a1.553 1.553 0 0 0 2.731 0h.645a1.171 1.171 0 0 1 1.175 1.17zm8.543-13.194h1.482l.37 1.462-.056.089a1.647 1.647 0 0 1-2.11 0l-.057-.09zm.741 12.577l-1.852-2.34 1.067-7.862a2.236 2.236 0 0 0 .785.144 2.235 2.235 0 0 0 .784-.144l1.067 7.862z",
  className: "cls-3",
  transform: "translate(0 -40.812)"
})))));

function SvgNewTrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220.196,
    height: 220.196,
    viewBox: "0 0 220.196 220.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTrip);
export default __webpack_public_path__ + "static/media/newTrip.693da37a.svg";
export { ForwardRef as ReactComponent };